import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, alpha, useTheme } from '@mui/material';
import { APP_SHAPE } from '../../constants/colors';
import { authSubmitButtonSx } from './authPage.styles';

interface AuthSuccessPanelProps {
  icon: React.ReactNode;
  title: string;
  message: string;
  actionLabel: string;
  actionTo?: string;
}

const AuthSuccessPanel: React.FC<AuthSuccessPanelProps> = ({
  icon,
  title,
  message,
  actionLabel,
  actionTo = '/login',
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: 'center',
        px: { xs: 1, sm: 2 },
        py: 3,
        borderRadius: `${APP_SHAPE.radiusMd}px`,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2.5,
          bgcolor: alpha(theme.palette.success.main, 0.12),
          color: 'success.main',
        }}
      >
        {icon}
      </Box>

      <Typography component="h2" variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.6, maxWidth: 320, mx: 'auto' }}
      >
        {message}
      </Typography>

      <Button
        component={RouterLink}
        to={actionTo}
        variant="contained"
        size="large"
        fullWidth
        sx={{ ...authSubmitButtonSx(theme), mt: 0 }}
      >
        {actionLabel}
      </Button>
    </Box>
  );
};

export default AuthSuccessPanel;
